import { WealthicaStorage } from '../../utils/storage';
import { logger } from '@/services/LoggingService';

/**
 * Safe storage helpers for navigation state.
 */
export function saveToStorage(key: string, value: string): boolean {
  try {
    WealthicaStorage.setItem(key, value);
    return true;
  } catch (e) {
    logger.error('Wealthica2NavigationProvider', 'Storage write failed', {
      key,
      error: e instanceof Error ? e.message : String(e)
    });
    return false;
  }
}

export function getFromStorage(key: string, defaultValue: string | null = null): string | null {
  try {
    return WealthicaStorage.getItem(key);
  } catch (e) {
    logger.error('Wealthica2NavigationProvider', 'Storage read failed', {
      key,
      error: e instanceof Error ? e.message : String(e)
    });
    return defaultValue;
  }
}
